import React, { memo } from 'react';

import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import View from '@/components/atomic/atoms/layout/view';
import ErrorBoundary from '@/components/atomic/atoms/utils/error-boundary';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import SliceNames from '@/state/enum';
import getBrand from '@/state/selectors/brand/get-brand';
import getIcons from '@/state/selectors/icons/get-icons';
import { BrandState } from '@/state/slices/brand/typings';
import { BasicComponentProps } from '@/typings/generic';
import loadableRetry from '@/utils/loadable-retry';
import loadable from '@loadable/component';

const IconBrick = loadable(
	(props: {
		icon: IconNames;
		brand: BrandState[SliceNames.BRAND]['brand'];
	}) =>
		loadableRetry(
			() =>
				import(
					`@/components/atomic/atoms/data-display/icons/bricks/${props.icon}.${props.brand}.tsx`
				),
		),
	{
		cacheKey: (props) => `${props.icon}.${props.brand}`,
	},
);

const IconsSpriteComponent: React.FC<BasicComponentProps> = ({
	$exposerSuffix,
}) => {
	const icons = useStore(getIcons);
	const brand = useStore(getBrand);

	if (!brand) return null;

	return (
		<View $display='none' $exposerSuffix={$exposerSuffix}>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				xmlnsXlink='http://www.w3.org/1999/xlink'
			>
				<defs>
					{icons.map((icon) => (
						<ErrorBoundary key={`${icon}_${brand}`}>
							<IconBrick icon={icon} brand={brand} />
						</ErrorBoundary>
					))}
				</defs>
			</svg>
		</View>
	);
};

const IconsSprite = memo(withExposer(IconsSpriteComponent, 'iconsSprite'));

export default IconsSprite;
